// tslint:disable
// @ts-ignore
import * as React from "react";
import { Checkbox } from "@material-ui/core";
import { ConfirmationModal } from "src/common/components";

export default function TableCheckbox(props: any) {
  const { t, testDataId } = props;
  const [selected, setSelected] = React.useState(props.isIncluded);
  const [open, setOpen] = React.useState(false);
  const [isRemovedOnce, setIsRemovedOnce] = React.useState(false);

  const reset = props.refresh.find((item: any) => {
    return item[props.data.id] === props.data.id;
  });

  React.useEffect(() => {
    if (reset) {
      setSelected(props.isIncluded);
    }
  }, [reset]);

  React.useEffect(() => {
    setSelected(props.isChecked);
  }, [props.isChecked]);

  const handleChange = () => {
    if (props.isIncluded && !isRemovedOnce) {
      setOpen(true);
    } else {
      if (selected) {
        setSelected(false);
        props.handleUncheck(props.data);
      } else {
        setSelected(true);
        props.handleCheck(props.data);
      }
    }
  };

  const handleConfirm = () => {
    setSelected(!selected);

    props.handleUncheck(props.data);

    setIsRemovedOnce(true);
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
    setIsRemovedOnce(false);
  };

  return (
    <>
      <ConfirmationModal
        onConfirm={handleConfirm}
        onCancel={handleClose}
        message={t(`feedback.page.my-employees.removeModal.message`)}
        title={t(`feedback.page.my-employees.options.remove`)}
        openModal={Boolean(open)}
      />
      <Checkbox checked={selected} onChange={handleChange} disabled={props.disabled} data-qa-selector={testDataId} />
    </>
  );
}
